import React from 'react'

const UserRoles = ({userRole}) => {
  return (
        <p className='text-left text-gray-500 text-xs'>{userRole.name}</p>
    )
}

export default UserRoles